import React from 'react';
import { InputTextarea } from 'primereact/inputtextarea';
import InputWrapper from './InputWrapper';

const PrimeInputTextArea = ({ value, onChange, placeholder, label, error }) => {
  return (
    <InputWrapper label={label} error={error}>
      <InputTextarea className="w-100" value={value} onChange={onChange} placeholder={placeholder} rows={5} />
    </InputWrapper>
  );
};

export default PrimeInputTextArea;
